var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrustyou(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.742,
    height: 66.062,
    viewBox: "0 0 90.742 66.062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_15",
    "data-name": "Gruppe 15",
    transform: "translate(-1843.771 -496.399)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_4_2",
    "data-name": "4,2",
    transform: "translate(1862.846 551.461)",
    fill: "#fff",
    fontSize: 42,
    fontFamily: "RobotoCondensed-Regular, Roboto Condensed"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4,2")), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2",
    "data-name": "Gruppe 2",
    transform: "translate(1843.771 496.399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Differenzmenge_2",
    "data-name": "Differenzmenge 2",
    d: "M8.975,43.323H0A45.4,45.4,0,0,1,77.486,13.3,45.264,45.264,0,0,1,90.741,43.32H83.548A37.416,37.416,0,0,0,11.8,31.75,37.13,37.13,0,0,0,8.975,43.322Z",
    transform: "translate(0 0.001)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Differenzmenge_5",
    "data-name": "Differenzmenge 5",
    d: "M8.976,43.323H0a45.406,45.406,0,0,1,73.333-33.7l-4.145,7.129A37.393,37.393,0,0,0,8.976,43.322Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustyou);
export default __webpack_public_path__ + "static/media/trustyou.4b3727de2b95391dc047124d7e42a81b.svg";
export { ForwardRef as ReactComponent };